import { Component, OnInit } from '@angular/core';
import { CommentingService } from '../../scaffold/services/commenting.service';
import { ScaffoldSidebarRef } from "@app/framework/sidebar/scaffold-sidebar.service";
import { take } from 'rxjs/operators';
import { ViewUpdateService } from '../../scaffold/services/view-update.service';

@Component({
  selector: 'app-comment-sidebar',
  templateUrl: './comment-sidebar.component.html',
  styleUrls: ['./comment-sidebar.component.scss']
})
export class CommentSidebarComponent implements OnInit {
  item;
  info;
  label;
  subItem;
  details;


  constructor(public commentor: CommentingService,
              private sidebarRef: ScaffoldSidebarRef,
              private viewUpdate: ViewUpdateService) { }

  ngOnInit(): void {
    console.log(this.info, this.item, this.label, this.subItem, this.details, this.sidebarRef);
    this.commentor.setActive(this.info, this.item, this.label, this.subItem, this.details, this.sidebarRef);
    this.viewUpdate.monitorRouteChanges().pipe(take(1)).subscribe(e => {
      this.close();
    });
  }

  close() {
    this.commentor.setActive(null, null, null, null, null, this.sidebarRef);
    this.sidebarRef.close();
  }



}
